import React, { useEffect, useState, useContext } from "react";
import { ContextAPI } from "../../../../ContextAPI";
import {
  Table,
  Typography,
  Divider,
  Popconfirm,
  Button,
  Dropdown,
  Icon,
  Menu,
  Input,
  Pagination,
  Modal,
  DatePicker,
  Select,
} from "antd";
import { platformApi } from "../../../../api";
import AddVehicleTransferModal from "./AddVehicleTransferModal";
import moment from "moment";
import VehicleName from "../../../VehicleName";

const { Title } = Typography;
const { Search } = Input;
const { Item } = Menu;
const { Option } = Select;
const PAGE_SIZE_OPTIONS = [5, 10, 15, 20];

const AddVehicleInventory = () => {
  const [addFlag, setAddFlag] = useState(false);
  const [createAccess, setCreateAccess] = useState(false);
  const { loginCredintials } = useContext(ContextAPI);
  const [vehicleTransfers, setVehicleTransfers] = useState([]);
  const [count, setCount] = useState(0);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [imageModal, setImageModal] = useState({ visible: false, url: "" });
  const [showAdvanced, setShowAdvanced] = useState(false);
  const [branchOptions, setBranchOptions] = useState([]);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [fromBranch, setFromBranch] = useState(undefined);
  // const [toBranch, setToBranch] = useState(undefined);
  const [filters, setFilters] = useState({});

  useEffect(() => {
    getVehicleTransfers();
    // eslint-disable-next-line
  }, [page, limit, filters]);

  useEffect(() => {
    getBranch();
  }, []);

  useEffect(() => {
    if (loginCredintials && loginCredintials.roleAccess) {
      loginCredintials.roleAccess.forEach((each) => {
        if (each.subModule === "transfer_vehicles") {
          if (each.access.create) {
            setCreateAccess(true);
          }
        }
      });
    }
  }, [loginCredintials]);

  const getVehicleTransfers = () => {
    setLoading(true);
    platformApi
      .post(`/api/inventoryTransfers/vehicle-transfers`, {
        size: limit,
        page,
        ...filters,
      })
      .then((res) => {
        setVehicleTransfers(res.data.data || []);
        setCount(res.data.count || 0);
      })
      .finally(() => setLoading(false));
  };

  const getBranch = () => {
    platformApi.get(`/api/user/branch`).then((res) => {
      setBranchOptions(res.data.data);
    });
  };

  // Search input handler
  const handleSearch = (value) => {
    setFilters((prev) => ({ ...prev, searchString: value || undefined }));
    setPage(1);
  };

  const handlePageChange = (pageNum) => {
    setPage(pageNum);
  };

  const handlePageSizeChange = (menu) => {
    setLimit(menu);
    setPage(1);
  };

  const getMenu = () => {
    return PAGE_SIZE_OPTIONS.map((menu) => (
      <Item onClick={() => handlePageSizeChange(menu)} key={menu}>
        {menu}
      </Item>
    ));
  };

  const menu = <Menu>{getMenu()}</Menu>;

  const columns = [
    {
      title: "S.no",
      dataIndex: "sno",
      key: "sno",
      render: (text, record, index) => (page - 1) * limit + index + 1,
      width: 60,
    },
    {
      title: "Date",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (date) => moment(date).format("DD-MM-YYYY"),
      width: 160,
    },
    {
      title: "From Branch",
      dataIndex: "fromBranchName",
      key: "fromBranchName",
      width: 140,
    },
    {
      title: "To Branch",
      dataIndex: "toBranchName",
      key: "toBranchName",
      width: 140,
    },
    {
      title: "Model",
      key: "model",
      render: (text, record) => (
        <VehicleName modelCode={record.modelCode} modelName={record.modelName} />
      ),
      width: 345,
    },
    {
      title: "Color",
      key: "color",
      render: (text, record) => (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          {record.colorUrl && (
            <div
              style={{
                width: 60,
                height: 60,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#f7f7f7",
                borderRadius: 4,
                border: "1px solid #eee",
                marginRight: 6,
                cursor: "pointer",
              }}
              onClick={() => setImageModal({ visible: true, url: record.colorUrl, colorCode: record.colorCode, color: record.color })}
            >
              <img
                src={record.colorUrl}
                alt={record.color}
                style={{
                  maxWidth: "58px",
                  maxHeight: "58px",
                  objectFit: "contain",
                  display: "block",
                }}
              />
            </div>
          )}
          {/* <span>{record.colorCode}</span> */}
        </div>
      ),
      width: 100,
    },
    {
      title: "Chassis Number",
      dataIndex: "chassisNo",
      key: "chassisNo",
      width: 220,
    },
  ];

  // Advanced filter search handler
  const handleAdvancedSearch = () => {
    const newFilters = {
      ...filters,
      fromBranch,
      startDate: fromDate ? fromDate.format("YYYY-MM-DD") : undefined,
      endDate: toDate ? toDate.format("YYYY-MM-DD") : undefined,
    };
    setFilters(newFilters);
    setPage(1);
  };

  // Advanced filter clear handler
  const handleAdvancedClear = () => {
    setFromDate(null);
    setToDate(null);
    setFromBranch(undefined);
    // setToBranch(undefined);
    setFilters({});
    setPage(1);
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: 16,
        }}
      >
        <Title level={4} style={{ margin: 0 }}>
          Vehicle Transfer [{count}]
          <span style={{ marginLeft: 12 }}>
            <Dropdown overlay={menu} trigger={["click"]}>
              <Button style={{ minWidth: 50 }}>
                {limit} <Icon type="down" />
              </Button>
            </Dropdown>
          </span>
        </Title>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <Search
            style={{ width: 220 }}
            placeholder="Search Transfers"
            onSearch={handleSearch}
            allowClear
            size="default"
          />
          <Button
            style={{
              border: "1.5px solid #008080",
              color: "#008080",
              background: "#fff",
              borderRadius: 4,
              fontWeight: 500,
            }}
            onClick={() => setShowAdvanced((prev) => !prev)}
          >
            {showAdvanced ? "Back" : "Advanced Filters"}
          </Button>
          <Button
            type="primary"
            style={{ minWidth: 180 }}
            onClick={() => setAddFlag(true)}
            disabled={!createAccess}
          >
            Add Vehicle Transfer
          </Button>
        </div>
      </div>
      <Divider style={{ margin: "8px 0 16px 0" }} />

      {/* Advanced Filters Section */}

      {showAdvanced && (
        <div
          style={{
            background: "#f7fafd",
            border: "1px solid #e0e0e0",
            borderRadius: 8,
            padding: 24,
            margin: "18px 0 8px 0",
          }}
        >
          <div
            style={{
              display: "flex",
              gap: 32,
              flexWrap: "nowrap",
              alignItems: "center",
              width: "100%",
              minWidth: 700,
              overflowX: "auto",
            }}
          >
            <div
              style={{ display: "flex", alignItems: "center", minWidth: 260 }}
            >
              <label style={{ fontWeight: 500, whiteSpace: "nowrap" }}>
                From Branch:
              </label>
              <Select
                style={{ marginLeft: 8, minWidth: 160 }}
                value={fromBranch}
                onChange={(val) => setFromBranch(val)}
                allowClear
                placeholder="Select Branch"
                showSearch
                optionFilterProp="children"
              >
                {branchOptions.map((branch) => (
                  <Option key={branch.id} value={branch.id}>
                    {branch.name}
                  </Option>
                ))}
              </Select>
            </div>
            <div
              style={{ display: "flex", alignItems: "center", minWidth: 220 }}
            >
              <label style={{ fontWeight: 500, whiteSpace: "nowrap" }}>
                From Date:
              </label>
              <DatePicker
                style={{ marginLeft: 8, width: 140 }}
                value={fromDate}
                onChange={(date) => setFromDate(date)}
                format="YYYY-MM-DD"
                allowClear
                placeholder="Start date"
                disabledDate={(current) => {
                  // Disable dates after To Date if To Date is selected
                  if (toDate && current) {
                    return current && current > toDate.endOf('day');
                  }
                  return false;
                }}
              />
            </div>
            <div
              style={{ display: "flex", alignItems: "center", minWidth: 220 }}
            >
              <label style={{ fontWeight: 500, whiteSpace: "nowrap" }}>
                To Date:
              </label>
              <DatePicker
                style={{ marginLeft: 8, width: 140 }}
                value={toDate}
                onChange={(date) => setToDate(date)}
                format="YYYY-MM-DD"
                allowClear
                placeholder="End date"
                disabledDate={(current) => {
                  // Disable dates before From Date if From Date is selected
                  if (fromDate && current) {
                    return current && current < fromDate.startOf('day');
                  }
                  return false;
                }}
              />
            </div>
            <Button
              type="primary"
              onClick={handleAdvancedSearch}
            >
              Search
            </Button>
            <Button onClick={handleAdvancedClear}>Clear</Button>
          </div>
        </div>
      )}

      <Table
        rowKey={(record) => record.id}
        columns={columns}
        dataSource={vehicleTransfers}
        loading={loading}
        style={{ cursor: "pointer" }}
        pagination={false}
      />
      <div style={{ marginTop: 16, textAlign: "right" }}>
        <Pagination
          current={page}
          pageSize={limit}
          total={count}
          onChange={handlePageChange}
          showSizeChanger={false}
        />
      </div>
      <AddVehicleTransferModal
        open={addFlag}
        close={() => setAddFlag(false)}
        refreshData={getVehicleTransfers}
        createAccess={createAccess}
      />
      <Modal
        visible={imageModal.visible}
        footer={null}
        onCancel={() => setImageModal({ visible: false, url: "", colorCode: "", color: "" })}
        centered
        bodyStyle={{ textAlign: "center", padding: 0 }}
        width={300}
      >
        <img
          src={imageModal.url}
          alt="Vehicle"
          style={{ maxWidth: "100%", maxHeight: "40vh", objectFit: "contain" }}
        />
        <div style={{ marginTop: 12 }}><strong>Color : {imageModal.color} ({imageModal.colorCode})</strong></div>
        {/* <div style={{ marginTop: 12 }}><strong>Color Code : {imageModal.colorCode}</strong></div> */}
      </Modal>
    </div>
  );
};

export default AddVehicleInventory;
